// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__DBx5c","col":"styles_col__1vNC_","fulfillmentStatus":"styles_fulfillmentStatus__wa8dt","emailCol":"styles_emailCol__31avu"};